/**
 * 범위 내 랜덤 정수
 * @example randomBetween(1, 100) => 42
 */
export function randomBetween(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

/**
 * 랜덤 ID 생성 (영문소문자+숫자)
 * @example randomId() => 'x7k9m2p4'
 * @example randomId(16) => 'a3f8k2m9x7p4q1w5'
 */
export function randomId(length: number = 8): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''

  for (let i = 0; i < length; i++) {
    result += chars[Math.floor(Math.random() * chars.length)]
  }

  return result
}

/**
 * 랜덤 HEX 색상
 * @example randomHex() => '#A3F2C1'
 */
export function randomHex(): string {
  const hex = Math.floor(Math.random() * 0xffffff)
    .toString(16)
    .padStart(6, '0')
    .toUpperCase()

  return `#${hex}`
}

/**
 * 배열에서 랜덤 요소 추출
 * @example pickRandom(['사과', '바나나', '딸기']) => '바나나'
 */
export function pickRandom<T>(array: T[]): T {
  return array[Math.floor(Math.random() * array.length)]
}

/**
 * 배열을 랜덤으로 섞기 (Fisher-Yates)
 * - 원본 배열을 변경하지 않음
 *
 * @example shuffle([1, 2, 3, 4, 5]) => [3, 1, 5, 2, 4]
 */
export function shuffle<T>(array: T[]): T[] {
  const result = [...array]

  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[result[i], result[j]] = [result[j], result[i]]
  }

  return result
}
